export var version = "3.13.1";
//# sourceMappingURL=version.js.map